<template>
    <div class="page-wrap">
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon"
                                                         :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)">
                    </van-col>
                    <van-col span="12">
                        <div class="banner-title">{{ $t('myJournal.title') }}</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="my-time-box">
            <div class="my-time-item" v-for="(item, index) in dateArr" :key="index"
                 :class="{ 'my-time-item-toggle': index === 6, 'my-time-item-active': selectedIndex === index }"
                 @click="selectItem(index)">
                <div class="my-time-week">{{ item.week }}</div>
                <div class="my-time-date" :class="{ 'my-time-today': item.isToday }">{{ item.date }}</div>
                <div class="my-time-have">
                    <van-icon name="success" size="0.32rem"/>
                </div>
            </div>
        </div>
        <div class="zowear-desc">Through long-term behavior tracking,ZOWEAR helps you see how daily behaviors influence
            recovery and health.
        </div>
        <div class="type-title">
            <div class="type-title-text" :class="{ 'type-title-text-active': typeSelectedIndex === 0 }"
                 @click="typeSelectedIndex = 0">STATUS
            </div>
            <div class="type-title-text" :class="{ 'type-title-text-active': typeSelectedIndex === 1 }"
                 @click="typeSelectedIndex = 1">BEHAVIORS
            </div>
        </div>
        <div class="type-content" v-if="typeSelectedIndex === 0">
            <div class="type-item" v-for="(title, index) in [
                'View a screened device while in bed？',
                'Use tobacco in any form？',
                'Sick？',
                'Business trip？',
                'Feel anxious？'
            ]" :key="index">
                <div class="type-item-title">{{ title }}</div>
                <div class="type-item-switch" @click="toggleSwitch(index)">
                    <div class="type-item-switch-false"
                         :class="{ 'type-item-switch-false-active': !switchActive[index] }">
                        <van-icon name="cross" size="0.32rem"/>
                    </div>
                    <div class="type-item-switch-true"
                         :class="{ 'type-item-switch-true-active': switchActive[index] }">
                        <van-icon name="success" size="0.32rem"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="type-content" v-if="typeSelectedIndex === 1">
            <div class="record-box">
                <div class="record-box-title">
                    <div class="record-box-title-left">
                        <img src="@/assets/theme/light/status/30myJournal/01record.svg">
                        Recent Record:
                    </div>
                    <div class="record-box-title-right">See All<img
                        src="@/assets/theme/light/status/30myJournal/02to.svg"></div>
                </div>
                <div class="record-box-content">12:00 - Alcohol (＜12% , 150ml)</div>
            </div>
            <div class="behaviors-type">
                <div class="behaviors-type-item"
                     v-for="(item, index) in behaviorsItems"
                     :key="index"
                     :class="{ 'behaviors-type-item-active': activeBehaviorIndex === index }"
                     @click="toggleBehavior(index)">
                    <img
                        :src="require(`@/assets/theme/light/status/30myJournal/${item.icon}${activeBehaviorIndex === index ? 'Active' : ''}.svg`)">
                    <div>{{ item.name }}</div>
                </div>
            </div>
            <div class="behaviors-title">CONCENTRATION</div>
            <div class="behaviors-type">
                <div class="concentration-item"
                     v-for="(item, index) in concentrationItems"
                     :key="index"
                     :class="{ 'behaviors-type-item-active': activeConcentrationIndex === index }"
                     @click="toggleConcentration(index)">
                    <div>{{ item.name }}</div>
                </div>
            </div>
            <div class="behaviors-title">VOLUME</div>
            <div class="volume-box">
                <input class="volume-input" type="number" v-model.number="num" min="0.0001"
                       @blur="num = num <=0 ? 1 : num"/>
                ml
            </div>
            <div class="behaviors-title">DRINKING TIME</div>
            <div class="volume-box">
                <input class="volume-input" @click="showPicker = true"/>
            </div>
        </div>
        <div class="done" @click="back">
            {{ typeSelectedIndex === 0 ? 'DONE' : 'LOG IT' }}
        </div>
        <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
                type="time"
                @confirm="onConfirm"
                @cancel="showPicker = false"
            />
        </van-popup>
    </div>
</template>

<script>
import {WebJSBridge} from "../../utils/JSBridge1";
import {getQueryVariable} from "../../utils/comment";

export default {
    name: '30myJournal',
    data() {
        return {
            ratio: 1,
            theme: getQueryVariable("theme") ? getQueryVariable("theme") : "light",
            selectedIndex: 6,
            typeSelectedIndex: 0,
            switchActive: [false, false, false, false, false],
            behaviorsItems: [
                {name: 'Coffee', icon: '03Coffee'},
                {name: 'Alcohol', icon: '03Alcohol'},
                {name: 'Milk', icon: '03Milk'},
                {name: 'Medicine', icon: '03Medicine'}
            ],
            concentrationItems: [
                {name: '＜12%'},
                {name: '12% - 20%'},
                {name: '20% - 45%'},
                {name: '45%+'}
            ],
            activeBehaviorIndex: -1,
            activeConcentrationIndex: -1,
            value: '',
            showPicker: false,
        }
    },
    computed: {
        dateArr() {
            const arr = [];
            const today = new Date();
            for (let i = 6; i >= 0; i--) {
                const d = new Date(today);
                d.setDate(today.getDate() - i);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const date = String(d.getDate()).padStart(2, '0');
                arr.push({
                    week: this.$t('myJournal.week' + d.getDay()),
                    date: date,
                    dateAll: `${year}-${month}-${date}`,
                    isToday: i === 0
                });
            }
            return arr;
        }
    },
    mounted() {
    },
    methods: {
        selectItem(index) {
            this.selectedIndex = index;
        },
        toggleSwitch(index) {
            this.$set(this.switchActive, index, !this.switchActive[index]);
        },
        toggleBehavior(index) {
            this.activeBehaviorIndex = this.activeBehaviorIndex === index ? -1 : index;
        },
        toggleConcentration(index) {
            this.activeConcentrationIndex = this.activeConcentrationIndex === index ? -1 : index;
        },
        back() {
            WebJSBridge.call("closeWeb", null, function (res) {
            });
        },
        onConfirm(time) {
            this.value = time;
            this.showPicker = false;
        },
    }
}
</script>

<style scoped>

.page-wrap {
    display: flex;
    flex-direction: column;
    height: 100vh;
}

.my-time-box {
    display: flex;
    align-items: center;
    margin-top: 88px;
    justify-content: center;
    gap: 6px;
}

.my-time-item {
    width: 44px;
    text-align: center;
    padding: 4px 0;
}

.my-time-week {
    font-size: 13px;
    color: var(--text-color-2);
}

.my-time-date {
    font-size: 15px;
    color: var(--text-color-1);
    margin: 7px auto;
    border-radius: 50%;
    width: 24px;
    height: 24px;
    line-height: 24px;
}

.my-time-have {
    font-size: 12px;
}

.my-time-today {
    color: var(--chart-color-8);
}

.my-time-item-active {
    background: var(--text-color-22);
    border-radius: 10px 10px 10px 10px;
}

.my-time-item-active .my-time-date {
    background: var(--chart-color-8);
    color: #fff;
}

.zowear-desc {
    width: 334px;
    height: 51px;
    font-size: 13px;
    color: var(--text-color-2);
    line-height: 18px;
    letter-spacing: 0.5px;
    margin: 12px auto 20px;
}

.type-title {
    display: flex;
    font-size: 15px;
    color: var(--text-color-3);
    width: 335px;
    margin: 0 auto 27px;
    padding-bottom: 6px;
    position: relative;
}

.type-title::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--text-color-22);
}

.type-title-text {
    margin-right: 24px;
    position: relative;
}

.type-title-text-active {
    color: var(--chart-color-8);
}

.type-title-text-active::after {
    content: '';
    position: absolute;
    bottom: -6px;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--chart-color-8);
    z-index: 1111;
}

.type-content {
    flex: 1;
    overflow-y: auto;
    scrollbar-width: none;
}

.type-content::-webkit-scrollbar {
    display: none;
}

.type-item {
    display: flex;
    width: 335px;
    margin: 0 auto 35px;
    justify-content: space-between;
    align-items: center;
}

.type-item-title {
    font-size: 13px;
    color: var(--text-color-1);
    width: 263px;
}

.type-item-switch {
    width: 70px;
    height: 24px;
    background: var(--bg-color-2);
    border-radius: 12px 12px 12px 12px;
    display: flex;
    color: var(--text-color-3);
}

.type-item-switch-false {
    width: 36px;
    height: 24px;
    border-radius: 12px 12px 12px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.type-item-switch-false-active {
    background: var(--bg-color-contrary);
    color: var(--bg-color-1);
}

.type-item-switch-true {
    width: 36px;
    height: 24px;
    border-radius: 12px 12px 12px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.type-item-switch-true-active {
    background: var(--chart-color-8);
    color: var(--bg-color-1);
}

.done {
    width: 345px;
    height: 49px;
    background: #121619;
    border-radius: 28px 28px 28px 28px;
    border: 2px solid var(--text-color-1);
    color: var(--text-color-1);
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 15px;
    margin-bottom: 20px;
}

.record-box {
    width: 345px;
    height: 62px;
    background: var(--chart-color-84);
    border-radius: 13px 13px 13px 13px;
    margin: auto;
    font-size: 13px;
}

.record-box-title {
    margin: 0 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;
}

.record-box-title div {
    display: flex;
    align-items: center;
    gap: 4px;
}

.record-box-title-right {
    color: var(--chart-color-8);
}

.record-box-content {
    margin-left: 28px;
    margin-top: 6px;
}

.behaviors-type-item {
    width: 74px;
    height: 67px;
    background: var(--bg-color-2);
    border-radius: 8px 8px 8px 8px;
}

.behaviors-type-item img {
    width: 24px;
    margin-top: 15px;
    margin-bottom: 0px;
}

.behaviors-type {
    width: 335px;
    display: flex;
    justify-content: left;
    gap: 13px;
    margin: 16px auto 20px;
    font-size: 13px;
    color: var(--text-color-3);
    text-align: center;
}

.behaviors-type-item-active {
    background: var(--chart-color-8) !important;
    color: #fff;
}

.behaviors-title {
    font-size: 13px;
    color: var(--text-color-3);
    margin-left: 20px;
    letter-spacing: 2px;
}

.concentration-item {
    width: 77px;
    height: 30px;
    background: var(--bg-color-2);
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.volume-box {
    margin-left: 20px;
    margin-top: 8px;
    color: var(--text-color-3);
    font-size: 13px;
    padding-bottom: 20px;
}

.volume-input {
    width: 74px;
    height: 30px;
    background: var(--bg-color-2);
    border-radius: 8px 8px 8px 8px;
    border: none;
    text-align: center;
    padding: 0;
    color: var(--text-color-1);
}
</style>



// WEBPACK FOOTER //
// src/views/status/30myJournal.vue